import { Link } from "react-router-dom";
import Logo from "./Logo";
import { NAV_ITEMS, PHONE_NUMBER, PHONE_TEL } from "./navigation";

interface MobileMenuProps {
  open: boolean;
  onClose: () => void;
}

export default function MobileMenu({ open, onClose }: MobileMenuProps) {
  return (
    <div
      className={`fixed inset-0 z-50 bg-white flex flex-col transition-all duration-300 md:hidden ${
        open ? "opacity-100 visible" : "opacity-0 invisible pointer-events-none"
      }`}
    >
      <div className="flex items-center justify-between px-5 h-16 border-b border-background-200">
        <Logo />
        <button
          type="button"
          onClick={onClose}
          className="w-10 h-10 flex items-center justify-center cursor-pointer"
          aria-label="메뉴 닫기"
        >
          <i className="ri-close-line text-3xl text-foreground-900"></i>
        </button>
      </div>

      <nav className="flex-1 flex flex-col justify-center px-8 gap-1">
        {NAV_ITEMS.map((item, index) => (
          <Link
            key={item.path}
            to={item.path}
            onClick={onClose}
            className="group flex items-center justify-between py-4 border-b border-background-100 cursor-pointer"
            style={{ animationDelay: `${index * 60}ms` }}
          >
            <span className="text-2xl font-heading text-foreground-900 group-hover:text-primary-600 transition-colors">
              {item.label}
            </span>
            <i className="ri-arrow-right-s-line text-2xl text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
          </Link>
        ))}
      </nav>

      <div className="px-8 pb-10 pt-6">
        <a
          href={PHONE_TEL}
          className="flex items-center gap-3 w-full rounded-2xl bg-primary-50 px-5 py-4 cursor-pointer"
        >
          <span className="w-11 h-11 rounded-full bg-primary-500 flex items-center justify-center">
            <i className="ri-phone-line text-white text-xl"></i>
          </span>
          <span className="flex flex-col">
            <span className="text-xs text-foreground-500">상담 전화</span>
            <span className="text-lg font-semibold text-foreground-900">{PHONE_NUMBER}</span>
          </span>
        </a>
      </div>
    </div>
  );
}